import React from 'react'
import PropTypes from 'prop-types'

import Candidate from '../../jobs/jobDetails/candidateListModal/candidate'
import { PaddedBottomDivider } from '../../ui'
import { CandidateWrapper, ShortBlock } from '../../jobs/jobDetails/styles'
import EshotModal from './modal'

export const EshotCandidate = ({ shortlist, setShortlist }) => {
  const updateSelection = (candidate, selection, setSelection) => {
    if (selection.includes(candidate)) {
      setSelection(selectedCandidateList =>
        selectedCandidateList.filter(
          selectedCandidate => selectedCandidate !== candidate,
        ),
      )
    } else {
      setSelection([...selection, candidate])
    }
  }
  return (
    <>
      {shortlist && shortlist.length > 0 ? (
        <>
          <PaddedBottomDivider />
          <section>
            <h3>E-Shot Shortlist</h3>
            <CandidateWrapper>
              {shortlist.map((candidate, index) => (
                <ShortBlock key={candidate.id}>
                  <Candidate
                    id={candidate.id}
                    jobTitle={candidate.job_title}
                    name={`${candidate.first_name} ${candidate.last_name}`}
                    email={candidate.contact_email}
                    onChange={() =>
                      updateSelection(candidate, shortlist, setShortlist)
                    }
                    value={shortlist
                      .map(selectedCandidate => selectedCandidate.id)
                      .includes(candidate.id)}
                    status={candidate.current_status}
                    action="select"
                  />
                </ShortBlock>
              ))}
            </CandidateWrapper>
          </section>
          {shortlist?.length >= 1 ? (
            <EshotModal
              candidatesShortlist={shortlist}
              setSelectedCandidatesShortlist={setShortlist}
            />
          ) : (
            <p style={{ marginTop: '1rem', fontWeight: '400' }}>
              Select candidates to create e-shot
            </p>
          )}
        </>
      ) : (
        <>
          <PaddedBottomDivider />
          <section>
            <h3>E-Shot Shortlist</h3>
            <p style={{ marginTop: '1rem', fontWeight: '400' }}>
              To send out E-Shots you must first create a shortlist
            </p>
          </section>
        </>
      )}
    </>
  )
}

EshotCandidate.defaultProps = {
  shortlist: [],
}

EshotCandidate.propTypes = {
  shortlist: PropTypes.array,
  setShortlist: PropTypes.func.isRequired,
}
